import { useTablePaginationContext } from 'modules/experiments/contexts';
import { getExperimentsTableDataState } from 'modules/experiments/ducks/selectors';
import { useSelector } from 'react-redux';
import { PAGE_SIZES_MEDIUM, PaginationFooter, PaginationUpdateEvent } from 'ui/paginationFooter';

export const ExperimentsIndexPagination = () => {
  const tableData = useSelector(getExperimentsTableDataState);
  const { page, pageSize, setPage, setPageSize } = useTablePaginationContext();

  const updatePagination = ({ page: newPage, pageSize: newPageSize }: PaginationUpdateEvent) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };

  return (
    <PaginationFooter
      onUpdate={updatePagination}
      pageSizes={PAGE_SIZES_MEDIUM}
      currentPage={page}
      itemsPerPage={pageSize}
      numItems={tableData.items?.info?.count}
    />
  );
};
